












import { Component, Prop, PropSync, Ref, Vue } from 'vue-property-decorator';
import DraggableEvent from './DraggableEvent.vue'
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component({
  components: {
    DraggableEvent
  }
})
export default class MonthlyCalendarDayArea extends Vue {
  @Prop({type: Number, required: true})
  public year!: number;
  @Prop({type: Number, required: true})
  public month!: number;
  @Prop({type: Number, required: true})
  public day!: number;
  @Prop({type: Function, required: true})
  public clickEvent!: (eventId: string) => void;

  @Prop({type: Function, required: true})
  public clickShowMoreEvent!: (dayAreaElement: Element, year: number, month: number, day: number) => void;

  private EVENT_HEIGHT: number = 21;

  private dayAreaHeight: number = 0;

  @Ref()
  private parentDiv!: HTMLDivElement;

  private eventSummaryFormat(event: any): string {
    return `${event.start.getHours()}:${`00${event.start.getMinutes()}`.slice(-2)} ${event.name}`
  }
  mounted() {
    this.$nextTick(function() {
      this.calcAreaHeight();
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.calcAreaHeight();
        }
      })
      resizeObserver.observe(this.parentDiv.parentElement!)
    })
  }
  private calcAreaHeight() {
    const totalHeight = this.parentDiv.parentElement?.clientHeight;
    const dayLabelElementheight = this.parentDiv.parentElement?.firstElementChild?.clientHeight;
    const dayLabelElementMargin = window.getComputedStyle(this.parentDiv.parentElement?.firstElementChild!).getPropertyValue("margin-top");
    this.dayAreaHeight = totalHeight! - dayLabelElementheight! - parseInt(dayLabelElementMargin);
  }
  get eventsInDate() {
    return (year: number, month: number, day: number) => {
      return shiftDataStore.eventsForCalendar.filter((event: any) => {
        return event.start.getFullYear() === year && event.start.getMonth() === month-1 && event.start.getDate() === day;
      }).sort((left: any, right: any) => {
        if(left.start.getTime() > right.start.getTime()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }
  get isShowMore() {
    return (year: number, month: number, day: number) => {
      const events = shiftDataStore.eventsForCalendar.filter((event: any) => {
        return event.start.getFullYear() === year && event.start.getMonth() === month-1 && event.start.getDate() === day;
      });
      return events.length * 21 > this.dayAreaHeight;
    }
  }
  get headEventsInDate() {
    const headCount = Math.floor(this.dayAreaHeight / this.EVENT_HEIGHT);
    return (year: number, month: number, day: number) => {
      return shiftDataStore.eventsForCalendar.filter((event: any) => {
        return event.start.getFullYear() === year && event.start.getMonth() === month-1 && event.start.getDate() === day;
      }).slice(0, headCount - 1);
    }
  }
  private onClickShowMore() {
    this.clickShowMoreEvent(this.$el, this.year, this.month, this.day)
  }
}
